import { Action, combineReducers, Reducer } from 'redux';
import { all, fork } from 'redux-saga/effects';
import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import { SagaIterator } from 'redux-saga';
import { ProcessFlowState, processFlowReducer } from '@shared/processFlow';
import { modalReducer, ModalState } from '@shared/components';
import { RegisterPharmacyState } from './registerPharmacy/types';
import { registerPharmacyReducer } from './registerPharmacy/reducer';
import registerPharmacySaga from './registerPharmacy/saga';
import { AuthState } from './auth';
import { authReducer } from './auth/reducer';
import { CoreState, coreReducer } from 'ff-shared-components-core';

export interface StoreState {
	coreState: CoreState<any>;
	authState: AuthState;
	router: any;
	processFlowState: ProcessFlowState;
	modalState: ModalState;
	registerPharmacyState: RegisterPharmacyState;
}

const appReducer = (history: History): Reducer => {
	return combineReducers({
		coreState: coreReducer,
		authState: authReducer,
		router: connectRouter(history),
		processFlowState: processFlowReducer,
		modalState: modalReducer,
		registerPharmacyState: registerPharmacyReducer,
	});
};

export const rootReducer = (history: History): Reducer => {
	return (state: any, action: Action): any => {
		const newState = { ...state };

		return appReducer(history)(newState, action);
	};
};

export function* rootSaga(): SagaIterator {
	yield all([fork(registerPharmacySaga)]);
}
